// 2026-07-07 — Shared display formatter for the Service Type enum.
// Backend stores UPPER_SNAKE values (SAME_DAY_PRIORITY); UI shows title case.
export const SERVICE_TYPE_LABELS = {
  HOME_SHOP: 'Home Shop',
  MINI_SHOP: 'Mini Shop',
  MOBILE_REQUEST: 'Mobile Request',
  ONSITE: 'Onsite',
  SAME_DAY_PRIORITY: 'Same Day Priority',
  TANK_QUALIFICATION: 'Tank Qualification',
};

export const formatServiceType = (v) =>
  v ? (SERVICE_TYPE_LABELS[v] || v.replace(/_/g, ' ')) : '';
